import {
  createAccountGroupMaster,
  CreateAccountGroupMasterMutation,
  CreateAccountGroupMasterMutationVariables,
  CustomListAccountGroupMasterQuery,
  deleteAccountGroupMaster,
  DeleteAccountGroupMasterMutation,
  DeleteAccountGroupMasterMutationVariables,
  importAccountGroupMaster,
  ImportAccountGroupMasterMutation,
  ImportAccountGroupMasterMutationVariables,
  listAccountGroupMasterCustom,
  ListAccountGroupMasterQueryVariables,
  updateAccountGroupMaster,
  UpdateAccountGroupMasterMutation,
  UpdateAccountGroupMasterMutationVariables,
} from '../../../graphql';
import { baseQuery } from '../../../utils';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const listGroupMasterApi = createApi({
  reducerPath: 'listGroupMasterApi',
  baseQuery: baseQuery,
  tagTypes: ['listGroupMaster'],
  endpoints: (builder) => ({
    listGroupMaster: builder.query<CustomListAccountGroupMasterQuery, ListAccountGroupMasterQueryVariables>({
      query: () => ({ body: listAccountGroupMasterCustom }),
      keepUnusedDataFor: 300,
      providesTags: ['listGroupMaster'],
    }),
    createAccountGroupMaster: builder.mutation<CreateAccountGroupMasterMutation, CreateAccountGroupMasterMutationVariables>({
      query: (variables) => ({ body: createAccountGroupMaster, variables }),
      invalidatesTags: ['listGroupMaster'],
    }),
    importAccountGroupMaster: builder.mutation<ImportAccountGroupMasterMutation, ImportAccountGroupMasterMutationVariables>({
      query: (variables) => ({ body: importAccountGroupMaster, variables }),
      invalidatesTags: ['listGroupMaster'],
    }),
    updateAccountGroupMaster: builder.mutation<UpdateAccountGroupMasterMutation,UpdateAccountGroupMasterMutationVariables>({
      query: (variables) => ({ body: updateAccountGroupMaster, variables }),
      invalidatesTags: ['listGroupMaster'],
    }),
    deleteAccountGroupMaster: builder.mutation<DeleteAccountGroupMasterMutation,DeleteAccountGroupMasterMutationVariables>({
      query: (variables) => ({ body: deleteAccountGroupMaster, variables }),
      invalidatesTags: ['listGroupMaster'],
    }),
  }),
});

export const {
  useListGroupMasterQuery,
  useCreateAccountGroupMasterMutation,
  useImportAccountGroupMasterMutation,
  useUpdateAccountGroupMasterMutation,
  useDeleteAccountGroupMasterMutation,
} = listGroupMasterApi;
